// Material Kit 2 React pages
import VicePrincipal from "pages/VicePrincipal";

export default function viceprincipal() {
  return <VicePrincipal />;
}
